import React from 'react';
import { Compass, Rocket, CloudSun, HeartHandshake, Wrench, Target, Zap, GraduationCap, BrainCircuit, DoorOpen } from 'lucide-react';
import { cn } from '@/lib/utils';

const ICONS = {
  Compass, Rocket, CloudSun, HeartHandshake, Wrench, Target, Zap, GraduationCap, BrainCircuit, DoorOpen,
};

const TONE = {
  primary: 'bg-primary/10 text-primary',
  accent: 'bg-accent/10 text-accent',
  success: 'bg-success/10 text-success',
  warning: 'bg-warning/10 text-warning',
  info: 'bg-info/10 text-info',
  secondary: 'bg-secondary/10 text-secondary',
  destructive: 'bg-destructive/10 text-destructive',
};

export const SuiteIcon = ({ name, color = 'primary', size = 'md', className }) => {
  const Icon = ICONS[name] || Compass;
  const sizes = { sm: 'h-8 w-8', md: 'h-11 w-11', lg: 'h-14 w-14' };
  const iconSizes = { sm: 'h-4 w-4', md: 'h-5 w-5', lg: 'h-6 w-6' };
  return (
    <div className={cn('rounded-xl flex items-center justify-center', TONE[color] || TONE.primary, sizes[size], className)}>
      <Icon className={iconSizes[size]} strokeWidth={2} />
    </div>
  );
};
